import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as variableOverrides from '../../../../variable-overrides'
import type { Feature } from '../feature'

/**
 * Put variable definitions for page when rendered page selection is changed
 */
export const putPageVariableDefinitions = store.effects.create(
  (feature: Feature, variablesFeature: variableOverrides.Feature) =>
    feature.selectors.rendering.asObservable.pipe(
      rxjs.filter(TypeChecker.isNotNullish.raw),
      rxjsUtils.latestFrom(pageRendering => ({
        context: feature.selectors.context.asObservable.pipe(
          rxjs.filter(TypeChecker.isNotNullish.raw),
        ),
        pageRendering: rxjs.of(pageRendering),
      })),
      rxjs.filter(
        ({ pageRendering }) => (pageRendering.variables ?? []).length > 0,
      ),
      rxjs.map(({ context, pageRendering }) =>
        variablesFeature.actions.putDefinitions
          .from('putPageVariableDefinitions (effect)')
          .create({
            holder: { page: { pageId: context.pageId } },
            variables: pageRendering.variables,
          }),
      ),
    ),
)
